export interface SEOData {
  title: string
  description: string
  image?: string
  url?: string
  type?: 'website' | 'article'
  author?: string
  publishedTime?: string
}

export function generateStructuredData(data: SEOData) {
  return {
    '@context': 'https://schema.org',
    '@type': data.type === 'article' ? 'Article' : 'WebSite',
    name: data.title,
    description: data.description,
    url: data.url,
    image: data.image,
    author: data.author ? {
      '@type': 'Organization',
      name: data.author
    } : undefined,
    publisher: {
      '@type': 'Organization',
      name: 'Avyrox Solutions',
      logo: {
        '@type': 'ImageObject',
        url: 'https://avyrox-solutions.com/logo.png'
      }
    },
    datePublished: data.publishedTime
  }
}

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Avyrox Solutions',
    url: 'https://avyrox-solutions.com',
    logo: 'https://avyrox-solutions.com/logo.png',
    description: 'Enterprise AI Platform Solutions',
    sameAs: [
      'https://www.linkedin.com/company/avyrox-solutions/',
      'https://x.com/AvyroxSolutions',
      'https://www.youtube.com/@AvyroxSolutions',
      'https://www.threads.net/@avyroxsolutions',
      'https://github.com/AvyroxSolutions',
      'https://substack.com/@avyroxsolutions'
    ]
  }
}

export function generateBreadcrumbSchema(breadcrumbs: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url
    }))
  }
}
